import { useMemo } from 'react';
import { useDatePickerStore } from './use-store';
import { generateCalendarGrid } from '../utils/generate-calendar-grid';
import { CalendarDay } from '../types';

/**
 * Custom hook that generates a calendar grid based on the current month from the DatePicker store
 *
 * @returns Array of 42 CalendarDay objects representing a complete 6-week calendar grid
 */
export function useCalendarGrid(): CalendarDay[] {
  const currentMonth = useDatePickerStore((state) => state.currentMonth);

  const calendarGrid = useMemo(() => {
    return generateCalendarGrid(currentMonth);
  }, [currentMonth]);

  return calendarGrid;
}
